import {
  LOGIN_TAB_CLOSE,
  LOGIN_TAB_OPEN,
  LOGIN_TAB_RESET,
  SIDE_NAV_CLOSE,
  SIDE_NAV_OPEN,
  SIDE_NAV_RESET,
  SIGNUP_TAB_CLOSE,
  SIGNUP_TAB_OPEN,
  SIGNUP_TAB_RESET,
} from '../constants/navigationConstants'

export const sideNavReducer = (state = { open: false, close: {} }, action) => {
  switch (action.type) {
    case SIDE_NAV_OPEN:
      return { open: true, close: false }
    case SIDE_NAV_CLOSE:
      return { open: false, close: true }
    case SIDE_NAV_RESET:
      return {}
    default:
      return state
  }
}

export const loginTabReducer = (state = { open: false, close: {} }, action) => {
  switch (action.type) {
    case LOGIN_TAB_OPEN:
      return { open: true, close: false }
    case LOGIN_TAB_CLOSE:
      return { open: false, close: true }
    case LOGIN_TAB_RESET:
      return {}
    default:
      return state
  }
}

export const signupTabReducer = (
  state = { open: false, close: {} },
  action
) => {
  switch (action.type) {
    case SIGNUP_TAB_OPEN:
      return { open: true, close: false }
    case SIGNUP_TAB_CLOSE:
      return { open: false, close: true }
    case SIGNUP_TAB_RESET:
      return {}
    default:
      return state
  }
}
